module.exports = __webpack_public_path__ + "img/MW.09c58d33.svg";